import React from 'react'
import datastore from '../datastore'
import { RichTextField } from './prismic-elements'
import { useLocation, useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../utils/helpers'

import './SearchBar.sass'

// Déclaration du composant
const SearchBar = ({ className, defaultValueJobs, defaultValueSectors, defaultValueCountries, defaultValueLocations, showCTA = true, enableAutoSearch = false }) => {
  const search_bar = datastore.layoutDoc.data.search_bar[0]
  // Récupération des paramètres tels que la langue, historique et requêtes
  const { pathname } = useLocation()
  const { lang } = useParams()
  const query = useQuery()
  const history = useHistory()

  if (query.get('job')) defaultValueJobs = query.get('job')
  if (query.get('sector')) defaultValueSectors = query.get('sector')
  if (query.get('country')) defaultValueCountries = query.get('country')
  if (query.get('location')) defaultValueLocations = query.get('location')

  // Setting des variables utilisables dans le state via useState. Chacune de ces variable est associé à son setter
  const [job, setJob] = React.useState(defaultValueJobs)
  const [sector, setSector] = React.useState(defaultValueSectors)
  const [country, setCountry] = React.useState(defaultValueCountries)
  const [location, setLocation] = React.useState(defaultValueLocations)

  // Déclaration de la fonction de recherche
  const doSearch = (useQuery) => {
    let url = (lang ? '/' + lang : '') + '/applicants/jobs'

    if (useQuery) {
      // if (query.get('job') === '') query.delete('job')
      // if (query.get('sector') === '') query.delete('sector')
      // if (query.get('country') === '') query.delete('country')
      // if (query.get('location') === '') query.delete('location')

      if (job) {
        query.set('job', job)
      } else {
        query.delete('job')
      }
      if ((!job || job === 'engineer' || job == 'engineering-consultant') && sector) {
      // if (sector) {
        query.set('sector', sector)
      } else {
        query.delete('sector')
      }
      if (country) {
        query.set('country', country)
      } else {
        query.delete('country')
      }
      if (country && country !== "" && location) {
        query.set('location', location)
      } else {
        query.delete('location')
      }

      url += '?' + query.toString()
    }

    history.push(url)
  }

  // 🧠 👉 Déclenche automatiquement la recherche quand un filtre change
  React.useEffect(() => {
    if (!enableAutoSearch) return;

    // let isMounted = true;
    /*
    const hasData =
    datastore.jobs?.length > 0 &&
    datastore.sectors?.length > 0 &&
    datastore.countriessearch?.length > 0
    */
    const hasData = true
    // const hasFilters = job || sector || country || location
    const hasFilters = true

    // if (isMounted && hasData && hasFilters) {
    if (hasData && hasFilters) {
      doSearch(true);
    }

    // return () => { isMounted = false };
  }, [job, sector, country, location]);

  // HTML Composant
  return (
    <div key={`${pathname}-${query.toString()}`} className={`search-bar-filter ${(className || '')}`}>
      <div className='search-bar-filter-form w-form'>
        <form className='search-bar-filter-form-normal'>
          <select
            className='search-bar-filter-dropdown w-select'
            aria-label={search_bar.option_job_label}
            defaultValue={defaultValueJobs}
            onChange={(e) => {
              // query.set('job', e.target.value)
              setJob(e.target.value)
            }}
          >
            <option value=''>{search_bar.option_job_label}</option>
            {
              datastore.jobs.map((item, index) => (
                <option key={index} value={item.uid}>{item.data.name}</option>
              ))
            }
          </select>
          {
            /*
            // Workaround ask by client 22/12/2020
            (!job || job === 'engineer') &&
              <select
                className='search-bar-filter-dropdown w-select'
                aria-label={search_bar.option_sector_label}
                value={sector || ''}
                defaultValue={defaultValueSectors}
                onChange={(e) => {
                  // query.set('sector', e.target.value)
                  setSector(e.target.value)
                }}
              >
                <option value=''>{search_bar.option_sector_label}</option>
                {
                  datastore.sectors.map((item, index) => (
                    <option key={index} value={item.uid}>{item.data.name}</option>
                  ))
                }
              </select>
            */  
          }
          <select
            className='search-bar-filter-dropdown w-select'
            aria-label={search_bar.option_sector_label}
            defaultValue={defaultValueSectors}
            disabled={!(!job || job === 'engineer' || job === 'engineering-consultant')}
            onChange={(e) => {
              // query.set('sector', e.target.value)
              setSector(e.target.value)
            }}
          >
            <option value=''>{search_bar.option_sector_label}</option>
            {
              datastore.sectors.map((item, index) => (
                <option key={index} value={item.uid}>{item.data.name}</option>
              ))
            }
          </select>
          <select
            className='search-bar-filter-dropdown w-select'
            aria-label={search_bar.option_country_label}
            defaultValue={defaultValueCountries}
            onChange={(e) => {
              // query.set('country', e.target.value)
              setCountry(e.target.value)
            }}
          >
            <option value=''>{search_bar.option_country_label}</option>
            {
              datastore.countriessearch.map((item, index) => (
                <option key={index} value={item.uid}>{item.data.name}</option>
              ))
            }
          </select>
          {
            (country && country !== "") &&
              <select
              className='search-bar-filter-dropdown w-select'
              aria-label={search_bar.option_location_label}
              defaultValue={defaultValueLocations}
              onChange={(e) => {
                // query.set('location', e.target.value)
                setLocation(e.target.value)
              }}
            >
              <option value=''>{search_bar.option_location_label}</option>
              {
                (datastore.locationssearch[country]) &&
                  datastore.locationssearch[country].map((item, index) => (
                      <option key={index} value={item.uid}>{item.data.name}</option>
                  ))
              }
            </select>
          }
          <input
            onClick={(e) => {
              e.preventDefault()
              doSearch(true)
            }}
            type='submit'
            value=''
            className='button-icon button-icon-search is-circle-secondary w-button'
          />
        </form>
      </div>
      {
        showCTA &&
          <div
            className='search-bar-filter-cta'
            onClick={() => doSearch(true)}
          >
            <RichTextField field={search_bar.cta} />
          </div>
      }
    </div>
  )
}

// Export par défaut du composant
export default SearchBar
